import { keyboardActionHandler } from '@utils/keyboardActionHandler';

import * as style from './style.module.css';

const Action = ({ action = null, target, className = '', variant = null, ...props }) => {
    const dest = action;
    const actionType = dest && typeof dest;
    const variantClass = variant ? (style[variant] ?? '') : '';

    if (actionType === 'function') {
        // Merge any caller-provided onClick with the action so both run: spreading {...props}
        // last would otherwise let an onClick prop override (clobber) the action handler.
        const { onClick, ...rest } = props;
        return (
            <span
                className={`${style.action} ${variantClass} ${className}`}
                onKeyDown={(e) => keyboardActionHandler(e, dest, 'Enter')}
                role={props.role}
                {...rest}
                onClick={(e) => {
                    onClick?.(e);
                    dest(e);
                }}
            />
        );
    }

    if (actionType === 'string' && dest[0] === '/') {
        return (
            <a
                className={`${style.action} ${variantClass} ${className}`}
                href={dest}
                {...(target ? { target } : {})}
                {...(target === '_blank' ? { rel: 'noopener noreferrer' } : {})}
                {...props}
            >
                {props.children}
            </a>
        );
    }

    if (actionType === 'string' && /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,25})+$/.test(dest)) {
        return (
            <a className={`${style.action} ${variantClass} ${className}`} href={`mailto:${dest}`} rel="noopener noreferrer" {...props}>
                {props.children}
            </a>
        );
    }

    if (actionType === 'string' && dest[0] === '#') {
        return (
            <a className={`${style.action} ${variantClass} ${className}`} href={dest} {...props}>
                {props.children}
            </a>
        );
    }

    if (actionType === 'string' && dest[0] !== '/') {
        // External links open in a new tab unless the caller passes another target, or null for none.
        const externalTarget = target === undefined ? '_blank' : target;
        return (
            <a
                className={`${style.action} ${style.link} ${variantClass} ${className}`}
                href={dest}
                rel="noopener noreferrer"
                {...(externalTarget ? { target: externalTarget } : {})}
                {...props}
            >
                {props.children}
            </a>
        );
    }

    return <span className={`${style.action} ${style.noaction} ${variantClass} ${className}`} {...props} />;
};

export default Action;
